import { type schemaType } from '~~/shared/api/strapi/vacaciones-landings/detail/schema'
import { type paramsType } from '~~/shared/api/strapi/vacaciones-landings/detail/paramsSchema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/vacaciones-landings/detail'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = (params: paramsType): Promise<returnType> =>
  strapiServerFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  strapiBrowserFetchWrapper<paramsType, schemaType>(endpoint, params)
